import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="contact-group-toggle"
export default class extends Controller {
  static targets = ['group', 'distributor', 'supplier']

  connect () {
    this.toggle()
  }

  toggle (_event) {
    const group = this.groupTarget.value

    // Show distributor for national_account_contacts or distributors
    if (group === 'national_account_contacts' || group === 'distributors') {
      this.distributorTarget.classList.remove('hidden')
    } else {
      this.distributorTarget.classList.add('hidden')
    }

    // Show supplier for suppliers group
    if (group === 'suppliers') {
      this.supplierTarget.classList.remove('hidden')
    } else {
      this.supplierTarget.classList.add('hidden')
    }
  }
}
